import React from "react";
import { Redirect } from "react-router-dom";
import {
  Breadcrumb,
  Card,
  Row,
  Col,
  Form,
  Input,
  Button,
  DatePicker,
  message,
  Alert,
  Modal,
  Table,
  Typography,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CarOutlined,
  SearchOutlined,
  IdcardOutlined,
  UserOutlined,
  CalendarOutlined,
  SafetyCertificateOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  TagOutlined,
} from "@ant-design/icons";
import moment from "moment";

import Config from "../../Config";

import { connect } from "react-redux";
import {
  initHandler,
  ajaxViewHandler,
  ajaxHandler,
  setConfig,
  extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
  title: "IWKBU",
  apiUrl: {
    kabupaten: "master/api/kabupaten/",
    kendaraan: "transaksi/api/tagihan/",
    iwkbu: "transaksi/api/tagihan/"
  },
  pageUrl: {
    cetak_no: "/addon/cetak_antrian/",
    redirect_url: "/admin/transaksi/iwkbu/"
  },
  breadCrumb: [
    <span>
      <CarOutlined /> Transaksi
    </span>,
    "IWKBU",
  ],
};

const config = new Config();

const FIELD_STYLE = {
  borderRadius: 8,
};

class FormIwkbu extends React.Component {
  formRef = React.createRef();
  formRefScroll = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      errComponent: false,
      errTitle: "",
      errMsg: "",

      isSukses: false,
      redirect_nopol: "",

      loadingButton: false,
      loadingCari: false,

      isModalRiwayat: false,

      cari_no_pol: undefined,

      isOpenForm: false,

      loadingDataKendaraan: false,
      dataKendaraan: null,

      pemilik_lama: null,

      merek_dipilih: "",
      jenis_kendaraan_dipilih: "",

      jenis: "Kendaraan Lama",

      aksi: "tambah",
      method: "post",
      idLama: "",

      modalBaru: false,

      field_requirements: {},

      kabupaten_dipilih: "",
      kecamatan_dipilih: "",

      modalKonfirmasi: false,

      isMobile: window.innerWidth <= 768,
      masaBerlakuPkb: "",
    };
  }

  UNSAFE_componentWillMount() {
    this.props.initHandler();
  }

  componentDidMount() {
    // this.getDataRiwayat();
    this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
    window.addEventListener("resize", this._handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._handleResize);
  }

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    //clearFilters();
    this.setState({ searchText: '', isOpenForm: false, cari_no_pol: undefined, masaBerlakuPkb: "" });
  };



  searchKendaraan = (no_polisi) => {
    if (!no_polisi || String(no_polisi).trim() === "") {
      message.warning({ content: "Nomor polisi harus diisi", duration: 2, key: "toast" });
      return;
    }
    this.setState({
      errComponent: false,
      errTitle: "",
    })
    this.previewData(no_polisi);
  };

  fmtTgl(val) {
    if (!val) return "-";
    const m = moment(val, ["YYYY-MM-DD", "DD-MM-YYYY"]);
    return m.isValid() ? m.format("DD-MM-YYYY") : val;
  }

  async previewData(no_polisi) {
    message.loading({
      content: "Proses pencarian...",
      duration: 0,
      key: "toast",
    });
    this.setState({ loadingCari: true });

    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.kendaraan + "?nomor_polisi=KH" + no_polisi
      )
      .then((action) => {
        const { isSuccess, responseMsg: datas } = extractResult(action);
        this.setState({ loadingCari: false });
        if (isSuccess) {
          if (datas.results.length == 0) {
            this.setState({
              isOpenForm: false,
            });
            message.destroy();
            message.error({ content: "nomor kendaraan tidak ditemukan", duration: 2, key: "toast" });
          } else {
            this.setState({
              isOpenForm: true,
            }, () => {
              if (this.formRefScroll.current) {
                this.formRefScroll.current.scrollTo(0, 0);
              }
            });
            const data = datas.results[0];
            //this.formRef.current.setFieldsValue(data);
            this.setState({
              pemilik_lama: data.pemilik,
              dataKendaraan: data,
              merek_dipilih: data.merek,
              jenis_kendaraan_dipilih: data.jenis_kendaraan,
              kabupaten_dipilih: data.kabupaten,
              kecamatan_dipilih: data.kecamatan,
              masaBerlakuPkb: `${data.masa_pajak}`,
              // modalKonfirmasi: data.tunggakan.is_popup != undefined && data.tunggakan.is_popup ? true : false
            }, () => {
              this.formRef.current.setFieldsValue(data);
              for (var key in data) {
                const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
                const dateTimeRegex =
                  /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;

                const dateRegex2 = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
                const dateTimeRegex2 =
                  /^[0-9]{4}\-[0-9]{2}\-[0-9]{2} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
                if (dateRegex.test(data[key])) {
                  //jika format tanggal DD-MM-YYYY
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: moment(data[key], "DD-MM-YYYY"),
                    [key]: data[key]
                  });
                } else if (dateTimeRegex.test(data[key])) {
                  //jika format tanggal dan jam DD-MM-YYYY HH:mm:ss
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: moment(data[key], "DD-MM-YYYY HH:mm:ss"),
                    [key]: data[key]
                  });
                } else if (dateRegex2.test(data[key])) {
                  //jika format tanggal YYYY-MM-DD - hidden field tetap disimpan
                  //DD-MM-YYYY karena itu format yang diharapkan backend saat submit.
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: moment(data[key], "YYYY-MM-DD"),
                    [key]: moment(data[key], "YYYY-MM-DD").format("DD-MM-YYYY")
                  });
                } else if (dateTimeRegex2.test(data[key])) {
                  //jika format tanggal dan jam YYYY-MM-DD HH:mm:ss
                  this.formRef.current.setFieldsValue({
                    [key + "_picker"]: moment(data[key], "YYYY-MM-DD HH:mm:ss"),
                    [key]: moment(data[key], "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY")
                  });
                } else if (key == "masa_pajak_mulai" || key == "masa_pajak_sampai" || key == "stnk_akhir" || key == "sd_notice") {
                  if (data[key] != null) {
                    this.formRef.current.setFieldsValue({
                      [key + "_picker"]: moment(data[key], ["YYYY-MM-DD", "DD-MM-YYYY"]),
                      [key]: data[key]
                    });
                  }
                }
              }

              message.destroy();
              this.setState({
                idLama: data.id + "/",
              });
            })
          }
        } else {
          const errTitle = "error preview data lama";
          this.setState({
            errTitle: errTitle,
            errMsg: datas,
          });
          message.destroy();
          message.error({ content: errTitle, duration: 2, key: "toast" });
        }
      })
      .catch((response) => {
        console.log("gagal_get_preview", response);
        this.setState({ loadingCari: false });
        message.error({
          content: "gagal request data, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  handleSubmit = (values) => {
    this.postDataPemilik(values);
  };

  reset() {
    this.formRef.current.setFieldsValue({
      pasien: undefined,
      jenis: "barcode",
    });
    this.resetPasien();
    this.setState({
      dataPasien: null,
      jenis: "barcode",
    });
    this.getDataRiwayat();
  }

  resetPasien() {
    // if (
    //   this.formRefPasien != undefined &&
    //   this.formRefPasien.current != undefined
    // ) {
    //   this.formRefPasien.current.resetFields();
    // }
  }

  async getDataPemilik(nik) {
    message.loading({
      content: "Pengecekan kepemilikan...",
      duration: 0,
      key: "toast",
    });

    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.pemilik +
        "?nik=" +
        nik
      )
      .then((action) => {
        const { isSuccess, responseMsg: datas } = extractResult(action);
        if (isSuccess) {
          if (datas.results != undefined) {
            const data = datas.results;
            if (data.length == 0) {
              message.warning({ content: "data kepemilikan tidak ditemukan", duration: 2, key: "toast" });
            } else {
              message.destroy();
            }
            for (var key in data) {
              const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
              const dateTimeRegex =
                /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;

              const dateRegex2 = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
              const dateTimeRegex2 =
                /^[0-9]{4}\-[0-9]{2}\-[0-9]{2} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
              if (dateRegex.test(data[key])) {
                //jika format tanggal
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "DD-MM-YYYY"),
                });
              } else if (dateTimeRegex.test(data[key])) {
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "DD-MM-YYYY HH:mm:ss"),
                });
              } else if (dateRegex2.test(data[key])) {
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "DD-MM-YYYY"),
                });
              } else if (dateTimeRegex2.test(data[key])) {
                this.formRef.current.setFieldsValue({
                  [key + "_picker"]: moment(data[key], "DD-MM-YYYY HH:mm:ss"),
                });
              } else {
                this.formRef.current.setFieldsValue({
                  [key]: data[key],
                });
              }
            }
          }
        } else {
          const errTitle = "error get data";
          message.error({ content: errTitle, duration: 2, key: "toast" });
        }
      })
      .catch((response) => {
        console.log("gagal_get_wp", response);
        message.error({
          content: "gagal cek wp, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  async postDataPemilik(datas) {
    message.loading({ content: "Memproses...", duration: 0, key: "toast" });
    this.setState({
      errTitle: "",
      errMsg: "",
      loadingButton: true,
    });
    this.props
      .ajaxHandler("post", configClass.apiUrl.iwkbu + this.state.idLama + "iwkbu/", datas, false, true)
      .then((action) => {
        const { isSuccess, responseMsg } = extractResult(action);
        if (isSuccess) {
          message.success({ content: 'berhasil mengaprove IWKBU', duration: 2, key: 'toast' });
          this.setState({ loadingButton: false });
          this.handleReset();
        } else {
          const errTitle = "gagal mengaprove IWKBU";
          message.error({ content: errTitle, duration: 2, key: "toast" });
          this.setState({
            loadingButton: false,
            errTitle: errTitle,
            errMsg: JSON.stringify(responseMsg),
          });
        }
      })
      .catch((response) => {
        console.log("gagal_post_pemilik", response);
        this.setState({
          loadingButton: false,
        });
        message.error({
          content: "kesalahan pengiriman data pemilik, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  async postDataKendaraan(datas, idPemilik) {
    var dataKendaraan = datas;
    dataKendaraan.pemilik = idPemilik;

    dataKendaraan.nomor_polisi =
      datas.no_polisi_depan + datas.no_polisi_tengah + datas.no_polisi_belakang;

    message.loading({ content: "Memproses...", duration: 0, key: "toast" });
    this.props
      .ajaxHandler(
        this.state.method,
        configClass.apiUrl.kendaraan + this.state.idLama,
        dataKendaraan,
        true,
        true
      )
      .then((action) => {
        const { isSuccess, responseMsg } = extractResult(action);
        if (isSuccess) {
          message.success({
            content: "berhasil menyimpan pendaftaran",
            duration: 2,
            key: "toast",
          });
          this.setState({
            pemilik_lama: null,
            loadingButton: false,
            isOpenForm: false,

            isSukses: true,
            redirect_nopol: datas.no_polisi_tengah + datas.no_polisi_belakang,
          });
        } else {
          const errTitle = "gagal menyimpan data kendaraan";
          message.error({ content: errTitle, duration: 2, key: "toast" });
          this.setState({
            loadingButton: false,
            errTitle: errTitle,
            errMsg: JSON.stringify(responseMsg),
          });
        }
      })
      .catch((response) => {
        console.log("gagal_post_kendaraan", response);
        this.setState({
          loadingButton: false,
        });
        message.error({
          content: "kesalahan pengiriman data kendaraan, coba lagi",
          duration: 2,
          key: "toast",
        });
      });
  }

  handleReset() {
    this.setState({
      isOpenForm: false,
      masaBerlakuPkb: "",
    });
  }

  loadMasterList() {
    const rule = [
      {
        destination: {
          stateProgressName: "loadingKabupaten",
          endPoint: configClass.apiUrl.kabupaten,
          stateDestination: "listKabupaten",
        },
        nextDestination: null
      },
    ];

    this.setState({
      errComponent: false,
    });

    rule.map((item, index) => {
      if (index == rule.length - 1) {
        this.getMasterList(item, true);
      } else {
        this.getMasterList(item);
      }
    });
  }

  async getMasterList(rule, isFinal = false) {
    var destination = rule.destination;
    var nextDestination = rule.nextDestination;
    this.setState({ [destination.stateProgressName]: true });
    this.props
      .ajaxViewHandler("get", destination.endPoint)
      .then((action) => {
        const { isSuccess, responseMsg: data } = extractResult(action);
        if (isSuccess) {
          if (data.count != undefined) {
            let newState = null;
            if (this.state[destination.stateDestination].length == 0) {
              newState = data;
            } else {
              if (destination.stateProgressName.includes("_searching")) {
                newState = data;
              } else {
                const oldState = this.state[destination.stateDestination];
                newState = {
                  count: data.count,
                  next: data.next,
                  previous: data.previous,
                  results: [...oldState.results, ...data.results],
                };
              }
            }
            this.setState({
              [destination.stateDestination]: newState,
            });
          } else if (data.results != undefined) {
            this.setState({
              [destination.stateDestination]: data.results,
            });
          } else {
            if (Array.isArray(data)) {
              this.setState({
                [destination.stateDestination]: data,
              });
            } else {
              this.setState({
                [destination.stateDestination]: [data],
              });
            }
          }
        } else {
          this.setState({
            errComponent: true,
          });
        }
        this.setState({ [destination.stateProgressName]: false });
      })
      .catch((response) => {
        message.error({
          content: "gagal request data, coba lagi",
          duration: 2,
          key: "toast",
        });
        this.setState({
          errTitle: "gagal request data master",
          errMsg: response,
        });
        this.setState({ [destination.stateProgressName]: false });
      });
    if (nextDestination != null) {
      const next = {
        destination: {
          stateProgressName: nextDestination.stateProgressName,
          endPoint: nextDestination.endPoint,
          stateDestination: nextDestination.stateDestination,
        },
        nextDestination: nextDestination.next,
      };
      this.getMasterList(next);
    }
  }

  cekIsRequired(fieldName) {
    return false;
  }

  // ── helper render: field display read-only (label di atas, input disabled) ──
  ReadField(label, name, span) {
    const { isMobile } = this.state;
    return (
      <Col xs={24} sm={12} md={span || 8}>
        <Form.Item label={label} name={name} style={{ marginBottom: isMobile ? 12 : 18 }}>
          <Input disabled style={FIELD_STYLE} />
        </Form.Item>
      </Col>
    );
  }

  render() {
    if (this.state.isSukses) {
      return <Redirect to={configClass.pageUrl.redirect_url + "?no_pol=" + this.state.redirect_nopol} />
    }

    const { isMobile, isOpenForm, loadingCari, loadingButton, cari_no_pol, masaBerlakuPkb } = this.state;

    return (
      <>
        <div>
          <Helmet>
            <title>
              {configClass.title + " | " + config.get_site_info().name}
            </title>
            <style>{`
              .iwkbu-card .ant-card-body { padding: 0; }
              .iwkbu-card { border-radius: 14px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.07); margin-bottom: 16px; }
              .iwkbu-section-header {
                padding: 14px 20px;
                background: linear-gradient(135deg, #0f284711, #1e4d8a11);
                border-bottom: 1.5px solid #d0dff5;
                display: flex;
                align-items: center;
                gap: 10px;
              }
              .iwkbu-section-header.amber {
                background: linear-gradient(135deg, #fa8c1611, #ad4e0011);
                border-bottom: 1.5px solid #ffd591;
              }
              .iwkbu-body { padding: 20px 20px 4px; }
              .iwkbu-form .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 12.5px; }
              .iwkbu-form .ant-input[disabled], .iwkbu-form .ant-picker-disabled {
                background: #f7f9fc !important;
                color: #344054 !important;
                border-radius: 8px !important;
              }
              .iwkbu-form .ant-input, .iwkbu-form .ant-picker { border-radius: 8px !important; }
              .iwkbu-search-bar .ant-input-group-addon,
              .iwkbu-search-bar .ant-input,
              .iwkbu-search-bar .ant-btn { height: 34px; }
              .iwkbu-search-bar .ant-input-group-addon { border-radius: 8px 0 0 8px !important; padding: 0 11px; }
              .iwkbu-search-bar .ant-input { border-radius: 0 8px 8px 0 !important; }
              .iwkbu-search-bar .ant-btn { border-radius: 8px !important; display: flex; align-items: center; justify-content: center; }
              @media (max-width: 480px) {
                .iwkbu-body { padding: 16px 14px 2px; }
                .iwkbu-section-header { padding: 12px 14px; }
              }
            `}</style>
          </Helmet>

          {/* ── Header gradient + search ── */}
          <Card className="iwkbu-card">
            <div
              style={{
                padding: "18px 20px",
                background: "linear-gradient(135deg, #0f2847, #1e4d8a)",
                display: "flex",
                alignItems: "center",
                gap: 14,
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  width: 46, height: 46, borderRadius: 12,
                  background: "rgba(255,255,255,0.15)",
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}
              >
                <SafetyCertificateOutlined style={{ color: "#fff", fontSize: 22 }} />
              </div>
              <div style={{ flex: 1, minWidth: 220 }}>
                <div style={{ color: "#fff", fontWeight: 700, fontSize: 17 }}>
                  Approval IWKBU
                </div>
                <div style={{ color: "rgba(255,255,255,0.7)", fontSize: 12, marginTop: 2 }}>
                  Cari transaksi berdasarkan nomor polisi untuk diapprove petugas Jasa Raharja
                </div>
              </div>
            </div>

            <div style={{ padding: "16px 20px" }} className="iwkbu-search-bar">
              <Row gutter={8}>
                <Col xs={24} sm={16} md={10}>
                  <Input
                    allowClear
                    addonBefore="KH"
                    placeholder="cth: 1234XY"
                    value={cari_no_pol}
                    onChange={(e) => {
                      this.setState({ cari_no_pol: e.target.value.toUpperCase() });
                    }}
                    onPressEnter={() => this.searchKendaraan(this.state.cari_no_pol)}
                  />
                </Col>
                <Col xs={24} sm={8} md={6} style={{ marginTop: isMobile ? 8 : 0 }}>
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    loading={loadingCari}
                    block
                    style={{ background: "#1e4d8a", border: "none" }}
                    onClick={() => this.searchKendaraan(this.state.cari_no_pol)}
                  >
                    Cari
                  </Button>
                </Col>
              </Row>
            </div>
          </Card>

          <ErrorAlertModal
            visible={this.state.errTitle != null && this.state.errTitle !== ''}
            title={this.state.errTitle}
            error={this.state.errMsg}
            onClose={() => this.setState({ errTitle: '', errMsg: '' })}
          />

          {isOpenForm && (
            <div ref={this.formRefScroll}>
              <Form
                layout="vertical"
                name="fdata"
                onFinish={this.handleSubmit}
                ref={this.formRef}
                className="iwkbu-form"
                initialValues={{
                  no_polisi_depan: "KH",
                  is_next: false,
                }}
              >
                <Form.Item name="is_next" style={{ display: "none" }}>
                  <Input type="hidden" />
                </Form.Item>

                {/* ── Identitas Kendaraan & Pemilik ── */}
                <Card className="iwkbu-card">
                  <div className="iwkbu-section-header">
                    <CarOutlined style={{ color: "#1e4d8a", fontSize: 16 }} />
                    <Text strong style={{ fontSize: 14, color: "#0f2847" }}>
                      Identitas Kendaraan &amp; Pemilik
                    </Text>
                  </div>
                  <div className="iwkbu-body">
                    <Row gutter={12}>
                      {this.ReadField("Nomor Polisi", "nomor_polisi", 6)}
                      {this.ReadField("No. SKUM", "no_skum", 6)}
                      {this.ReadField("No. Kohir", "no_kohir", 6)}
                      {this.ReadField("Kepemilikan", "kepemilikan_nama", 6)}
                    </Row>
                    <Row gutter={12}>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item label={<><IdcardOutlined /> No. Identitas (NIK)</>} name="pemilik_nik" style={{ marginBottom: isMobile ? 12 : 18 }}>
                          <Input disabled style={FIELD_STYLE} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item label={<><UserOutlined /> Nama WP/Pemilik</>} name="pemilik_nama" style={{ marginBottom: isMobile ? 12 : 18 }}>
                          <Input disabled style={FIELD_STYLE} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item label={<><PhoneOutlined /> No. HP</>} name="pemilik_no_hp" style={{ marginBottom: isMobile ? 12 : 18 }}>
                          <Input disabled style={FIELD_STYLE} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={12}>
                      <Col xs={24}>
                        <Form.Item label={<><EnvironmentOutlined /> Alamat WP/Pemilik</>} name="alamat_wp" style={{ marginBottom: isMobile ? 12 : 18 }}>
                          <Input disabled style={FIELD_STYLE} />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={12}>
                      {this.ReadField("Kode Fungsi", "fungsi_nama", 6)}
                      {this.ReadField("Jenis Kendaraan", "jenis_kendaraan", 6)}
                      {this.ReadField("Merk", "merk_kendaraan", 6)}
                      {this.ReadField("Golongan", "golongan_nama", 6)}
                    </Row>
                    <Row gutter={12}>
                      {this.ReadField("Tipe", "tipe_kendaraan", 6)}
                      {this.ReadField("Tahun Buat", "tahun_buat", 6)}
                      {this.ReadField("CC", "cc", 6)}
                      {this.ReadField("Warna", "warna", 6)}
                    </Row>
                    <Row gutter={12}>
                      {this.ReadField("No. Rangka", "nomor_rangka", 6)}
                      {this.ReadField("No. Mesin", "nomor_mesin", 6)}
                      {this.ReadField("Kode BBM", "bahan_bakar_nama", 6)}
                      {this.ReadField("Warna Plat", "warna_plat_nama", 6)}
                    </Row>
                    <Row gutter={12}>
                      {this.ReadField("No. BPKB", "no_bpkb", 6)}
                    </Row>
                  </div>
                </Card>

                {/* ── Informasi Tanggal ── */}
                <Card className="iwkbu-card">
                  <div className="iwkbu-section-header">
                    <CalendarOutlined style={{ color: "#1e4d8a", fontSize: 16 }} />
                    <Text strong style={{ fontSize: 14, color: "#0f2847" }}>
                      Informasi Tanggal
                    </Text>
                  </div>
                  <div className="iwkbu-body">
                    <Row gutter={12}>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item label="Tgl STNK" name="stnk_akhir_picker" style={{ marginBottom: isMobile ? 12 : 18 }}>
                          <DatePicker disabled format="DD-MM-YYYY" style={{ width: "100%", ...FIELD_STYLE }} placeholder="dd-mm-yyyy" />
                        </Form.Item>
                        <Form.Item name="stnk_akhir" style={{ display: "none" }}>
                          <Input type="hidden" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item label="Tgl SWDKLLJ" name="sd_notice_picker" style={{ marginBottom: isMobile ? 12 : 18 }}>
                          <DatePicker disabled format="DD-MM-YYYY" style={{ width: "100%", ...FIELD_STYLE }} placeholder="dd-mm-yyyy" />
                        </Form.Item>
                        <Form.Item name="sd_notice" style={{ display: "none" }}>
                          <Input type="hidden" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item label="Tgl Masa Berlaku PKB" style={{ marginBottom: isMobile ? 12 : 18 }}>
                          <Input disabled style={FIELD_STYLE} value={masaBerlakuPkb} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </Card>

                {/* ── Approval IWKBU ── */}
                <Card className="iwkbu-card">
                  <div className="iwkbu-section-header amber">
                    <SafetyCertificateOutlined style={{ color: "#ad4e00", fontSize: 16 }} />
                    <Text strong style={{ fontSize: 14, color: "#974f00" }}>
                      Approval IWKBU - Petugas Jasa Raharja
                    </Text>
                  </div>
                  <div className="iwkbu-body" style={{ paddingBottom: 20 }}>
                    <Alert
                      type="warning"
                      showIcon
                      message="Perhatian"
                      description="Mengubah Tgl IWKBU di sini akan ikut memperbarui data pada Master IWKBU dan data kendaraan terkait."
                      style={{ marginBottom: 16, borderRadius: 8 }}
                    />
                    <Row gutter={12}>
                      <Col xs={24} sm={12} md={8}>
                        <Form.Item
                          label={<><TagOutlined /> Tgl IWKBU</>}
                          name="tanggal_iwkbu_picker"
                          rules={[{ required: true, message: 'Tgl IWKBU harus diisi' }]}
                          style={{ marginBottom: 0 }}
                        >
                          <DatePicker
                            placeholder="dd-mm-yyyy"
                            format="DD-MM-YYYY"
                            style={{ width: "100%", ...FIELD_STYLE }}
                            onChange={(date, dateString) => {
                              this.formRef.current.setFieldsValue({
                                tanggal_iwkbu: dateString,
                              });
                            }}
                          />
                        </Form.Item>
                        <Form.Item name="tanggal_iwkbu" style={{ display: "none" }}>
                          <Input type="hidden" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <div
                      style={{
                        marginTop: 20,
                        paddingTop: 16,
                        borderTop: "1px solid #f0f0f0",
                        display: "flex",
                        gap: 10,
                        flexDirection: isMobile ? "column" : "row",
                        justifyContent: isMobile ? "stretch" : "flex-end",
                      }}
                    >
                      <Button
                        danger
                        icon={<CloseCircleOutlined />}
                        disabled={loadingButton}
                        style={{ borderRadius: 8, ...(isMobile ? { width: "100%" } : {}) }}
                        onClick={() => this.handleReset()}
                      >
                        Reset
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        icon={<CheckCircleOutlined />}
                        loading={loadingButton}
                        style={{
                          borderRadius: 8,
                          background: "linear-gradient(135deg, #ad4e00, #fa8c16)",
                          border: "none",
                          fontWeight: 600,
                          ...(isMobile ? { width: "100%" } : {}),
                        }}
                      >
                        Approve IWKBU
                      </Button>
                    </div>
                  </div>
                </Card>
              </Form>
            </div>
          )}
        </div>
        <Modal
          title="Riwayat Pemilik Kendaraan"
          visible={this.state.isModalRiwayat}
          footer={[]}
          closable={true}
          width={"80%"}
          onCancel={() => this.setState({ isModalRiwayat: false })}
        >
          <Table
            title={() =>
              <Row>
                <Col lg={8} sm={24} xs={24}><span className="konten-judul">Total {this.state.paginationRiwayat.total} record</span></Col>
                <Col lg={{ span: 8, offset: 8 }} sm={24} xs={24}>
                  <Input.Search
                    size="small"
                    placeholder="ketikkan pencarian"
                    onSearch={value => {
                      this.setState({
                        searchText: value
                      }, () => {
                        this.getDataRiwayat();
                      });
                    }}
                    allowClear
                  />
                </Col>
              </Row>
            }
            bordered
            columns={this.state.columnsRiwayat}
            dataSource={this.state.dataSourceRiwayat}
            loading={this.state.loadingDataRiwayat}
            scroll={{ x: 240, y: 450 }}
            size="small"
            pagination={this.state.paginationRiwayat}
            onChange={this.handleTableChangeRiwayat}
          />

        </Modal>

        <Modal
          title={this.state.dataModal != null ? this.state.dataModal.judul : ""}
          centered
          visible={this.state.visibleModal}
          onCancel={() => this.setState({ visibleModal: false })}
          width={700}
          footer={[]}
        >

          <Row>
            <Col span={24}>

              {(this.state.dataModal != null && this.state.dataModal.is_flat == true && Object.entries(this.state.dataModal.konten.value).map(([key, value]) => (
                <Row style={{ borderBottom: "1px solid #F0F2F6" }}>
                  <Col span={12}>{config.toSpace(key).toUpperCase()}</Col>
                  <Col span={12}>
                    {Array.isArray(value) ? ": " + JSON.stringify(value) : ": " + (value == null ? "-" : value)}
                  </Col>
                </Row>
              )))}
            </Col>
          </Row>
          <Row justify="end">
            <Col style={{ padding: 5 }}>
              <Button
                type="danger"
                key="btn-cancel"
                size="small"
                onClick={() => this.setState({ visibleModal: false })}
              >
                <CloseCircleOutlined /> Tutup
              </Button>
            </Col>
          </Row>


        </Modal>


      </>
    );
  }
}

const mapStateToProps = function (state) {
  return state.configReducers;
};

export default connect(mapStateToProps, {
  initHandler,
  setConfig,
  ajaxViewHandler,
  ajaxHandler,
})(FormIwkbu);
